/**
 * @fileoverview Mapbox / Harita Sabitleri
 *
 * Harita konfigurasyonu icin gerekli sabitler.
 *
 * @module utils/constants/mapbox
 */

/**
 * Mapbox erisim tokeni.
 * Environment variable olarak VITE_MAPBOX_TOKEN ile ayarlanmalidir.
 *
 * @constant {string}
 */
export const DEFAULT_MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN || "";

/**
 * Turkiye cografi sinirlari (bounding box).
 * Format: [[SW_lng, SW_lat], [NE_lng, NE_lat]]
 *
 * @constant {Array<[number, number]>}
 */
export const TURKEY_BOUNDS = [
  [25.5, 35.5],
  [45.0, 42.5],
];

/**
 * Varsayilan harita merkezi (Turkiye'nin yaklasik merkezi).
 * Format: [longitude, latitude]
 *
 * @constant {[number, number]}
 */
export const DEFAULT_MAP_CENTER = [35.0, 39.0];

/**
 * Harita zoom seviyeleri.
 *
 * @constant {Object}
 */
export const MAP_ZOOM = {
  DEFAULT: 6,
  LISTING: 10,
  SINGLE_MARKER: 12,
  MIN: 6,
  MAX: 18,
};
